// A custom reset to avoid issues with slider values on reset
var resetForm = function() {
	$('.filter-block-reset').on( 'click' , function(e) {
		e.preventDefault();

		// Get current path
		var currentPath = window.location.pathname;

		// Last path character
		var lastPathCharacter = currentPath.substr( currentPath.length - 1, currentPath.length );

		// If last character is slash, strip it
		if ( lastPathCharacter === '/' ) {
			var targetPath = currentPath.slice(0, -1);
		} else {
			var targetPath = currentPath;
		}

		// Reload page, and scroll to filter target
		window.location = targetPath + '?scrollOffset=true&scrollTarget=filter-reset-target';
	});
}

$(document).ready( resetForm );

var hideEmptyTerms = function() {
	if ( document.querySelector('.dynamic-filter-block') ) {
		$('.dynamic-filter-block li').each(function() {
			// Remove everything with a blank string for a value
			$(this).find('li').each(function() {
				if ( $(this).find('input').val() == '' ) {
					$(this).remove();
				}
			});
			// Don't hide active options OR options which have an active child
			if ( ! $(this).hasClass('sf-option-active') && ! $(this).find('.sf-option-active').length ) {
				/**
				 * Search & Filter provides a data attribute for checkboxes, called `data-sf-count`, which tells us
				 * how many results each term has. If this is zero, we can remove the element.
				 * We need to remove, rather than hide, so that we can accurately hide the `h4` headers
				 * for filters with no terms at all.
				 */
				if( $(this).data('sfCount') === 0 ) {
					$(this).remove();
				}
			}
		});

		$('.dynamic-filter-block h4').each(function() {
			// Loop through each header and, if there are no terms for the filter, hide the header
			if ( $(this).next('ul').length ) {
				if ( $(this).next('ul').html().trim() == '' ) {
					$(this).parent().remove();
				}
			}
		});

		if ( $('.dynamic-filter-block li').length < 3 ) {
			$('.dynamic-filter-block').remove();
			$('.filter-list').removeClass('filter-list--active');
			$('.filtered-grid').addClass('grid--4col-1000');
		}
	}
}

$(document).ready( hideEmptyTerms );

// Function to handle visual toggle of nested checkboxes in Search & Filter
var initialiseFilterChildToggle = function() {

	// Add button before each child list
	$('.nested-filter-block .children').before('<a class="filter-child-toggle">+</a>');

	// Add click handler to button
	$('.filter-child-toggle').on('click', function(e) {
		e.preventDefault();
		$(this).next('.children').toggleClass('children--expanded');
		if ( $(this).html() === '+' ) {
			$(this).html('–');
		} else {
			$(this).html('+');
		}
	});

	// Open any lists with children selected
	$('.nested-filter-block .children').each(function() {
		var list = $(this);
		$(this).find('input').each(function() {
			if ( $(this).attr('checked') ) {
				list.addClass('children--expanded');
				list.prev('.filter-child-toggle').html('–');
			}
		})
	});

};

$(document).ready( initialiseFilterChildToggle );
$(document).ajaxComplete( initialiseFilterChildToggle ); // Run on ajaxComplete in case any settings which use AJAX are turned on

// Ensure Kitchen & Wet Rooms Max is selected
var selectKitchenWetRoomsMax = function() {
	$('.sf-field-post-meta-number_of_kitchen_and_wet_rooms .sf-range-max .sf-input-radio:last-child input').attr('checked', 'checked');
}
$(document).ready( selectKitchenWetRoomsMax );
